import React from 'react'
import PropTypes from 'prop-types'
import NavigationHelper from 'layers/navigation/navigationHelper'
import ClassesGoal from '../ClassesGoal'
import CustomGoal from '../CustomGoal'
import LessonsGoal from '../LessonsGoal'
import { customGoalByKey } from '../goalHelpers'

const GoalContentPanel = ({
  classCreationGoalValue,
  goal1Date,
  goal2Date,
  goal3Date,
  goal3IsCompleted,
  goal3Text,
  goal4Date,
  goal4IsCompleted,
  goal4Text,
  goal5Date,
  goal5IsCompleted,
  goal5Text,
  isSingleSite,
  lessonCompletionGoalValue,
  lessonCompletionGoalIsDisabled,
  navigationEvent,
  onOpenGoalsModal,
  onOpenGoalsModalFromWarning,
  programStartDate,
  selectedGoal,
  showHeader,
  showMonitorViewOnly,
  siteId,
  sitePlaybookData,
  siteUserStats,
}) => {
  const layoutProps = { isSingleSite, showHeader, showMonitorViewOnly }
  const openGoalsModal = onOpenGoalsModal ?? (() => {})
  const openGoalsModalFromWarning =
    onOpenGoalsModalFromWarning ?? openGoalsModal

  switch (selectedGoal) {
    case 'goal 1':
      return (
        <ClassesGoal
          {...layoutProps}
          classCreationGoalValue={classCreationGoalValue}
          goalDate={goal1Date}
          onNavigateToUserManagement={url =>
            navigationEvent(url, NavigationHelper.types.OPEN)
          }
          onOpenGoalsModal={openGoalsModal}
          onOpenGoalsModalFromWarning={openGoalsModalFromWarning}
          siteId={siteId}
          sitePlaybookData={sitePlaybookData}
          siteUserStats={siteUserStats}
        />
      )
    case 'goal 2':
      return (
        <LessonsGoal
          {...layoutProps}
          goalDate={goal2Date}
          lessonCompletionGoalIsDisabled={lessonCompletionGoalIsDisabled}
          lessonCompletionGoalValue={lessonCompletionGoalValue}
          onOpenGoalsModal={openGoalsModal}
          onOpenGoalsModalFromWarning={openGoalsModalFromWarning}
          programStartDate={programStartDate}
          sitePlaybookData={sitePlaybookData}
        />
      )
    default: {
      const customGoal = customGoalByKey({
        goal3Date,
        goal3IsCompleted,
        goal3Text,
        goal4Date,
        goal4IsCompleted,
        goal4Text,
        goal5Date,
        goal5IsCompleted,
        goal5Text,
      })[selectedGoal]

      if (!customGoal) {
        return null
      }

      return (
        <CustomGoal
          {...layoutProps}
          goalDate={customGoal.date}
          goalText={customGoal.text}
          isCompleted={customGoal.isCompleted}
          onOpenGoalsModal={openGoalsModal}
          programStartDate={programStartDate}
          sitePlaybookData={sitePlaybookData}
        />
      )
    }
  }
}

GoalContentPanel.propTypes = {
  classCreationGoalValue: PropTypes.number,
  goal1Date: PropTypes.number,
  goal2Date: PropTypes.number,
  goal3Date: PropTypes.number,
  goal3IsCompleted: PropTypes.bool,
  goal3Text: PropTypes.string,
  goal4Date: PropTypes.number,
  goal4IsCompleted: PropTypes.bool,
  goal4Text: PropTypes.string,
  goal5Date: PropTypes.number,
  goal5IsCompleted: PropTypes.bool,
  goal5Text: PropTypes.string,
  isSingleSite: PropTypes.bool,
  lessonCompletionGoalIsDisabled: PropTypes.bool,
  lessonCompletionGoalValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  navigationEvent: PropTypes.func,
  onOpenGoalsModal: PropTypes.func,
  onOpenGoalsModalFromWarning: PropTypes.func,
  programStartDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedGoal: PropTypes.string,
  showHeader: PropTypes.bool,
  showMonitorViewOnly: PropTypes.bool,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sitePlaybookData: PropTypes.object,
  siteUserStats: PropTypes.shape({
    totalUsers: PropTypes.number,
    usersWithoutClasses: PropTypes.number,
    usersWithoutAccounts: PropTypes.number,
    usersLoggedInLast7Days: PropTypes.number,
  }),
}

export default GoalContentPanel
